import { render, staticRenderFns } from "./Western.vue?vue&type=template&id=5ad1867c&scoped=true"
import script from "./Western.vue?vue&type=script&lang=js"
export * from "./Western.vue?vue&type=script&lang=js"
import style0 from "./Western.vue?vue&type=style&index=0&id=5ad1867c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad1867c",
  null
  
)

export default component.exports